// extracted by mini-css-extract-plugin
module.exports = {"container":"IncrementDecrement_container__FudQn","plus":"IncrementDecrement_plus__2OEO8","price":"IncrementDecrement_price__1l8bX","minus":"IncrementDecrement_minus__1UNJD"};